interface TitleProps {
    title: string,
    titleClassname?: string,
    require?: boolean
}

const Title = ({ title, titleClassname, require = false }: TitleProps) => {
    return (
        <p className={`text-[15px] text-gray font-medium mt-4 ${titleClassname}`}>
            <span>
                {title}
                {' '}
            </span>
            {require && <span className='text-textRed'>*</span>}
        </p>
    );
};

export default Title;
